import ENV from "../../env";
import getAuthHeaders from "../authHeaders";

const deleteUser = async (user) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${ENV.firebaseApiUrl}/user/delete/${user.id}`, {
    method: "DELETE",
    headers,
    body: JSON.stringify({ user }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Delete user failed: " + resData.message);
  }

  return resData.userId;
};

export default deleteUser;
